import request from '@/utils/request'

const lading_billApi = {
  trade_lading_bill_list: '/trade/lading_bill/',
  trade_lading_bill_create: '/trade/lading_bill/',
  trade_lading_bill_update: '/trade/lading_bill/',
  trade_lading_bill_delete: '/trade/lading_bill/',
  trade_lading_bill_archived: '/trade/lading_bill_archived/',
  trade_lading_bill_attachment: '/trade/lading_bill_attachment/'
}

/**
 * 列表
 */
export function lading_bill_list (parameter) {
  return request({
    url: lading_billApi.trade_lading_bill_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function lading_bill_create (parameter) {
  return request({
    url: lading_billApi.trade_lading_bill_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function lading_bill_update (parameter, lading_bill_id) {
  return request({
    url: lading_billApi.trade_lading_bill_update + lading_bill_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function lading_bill_delete (lading_bill_id) {
  return request({
    url: lading_billApi.trade_lading_bill_delete + lading_bill_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function lading_bill_archived (parameter) {
  return request({
    url: lading_billApi.trade_lading_bill_archived,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 担保合同附件列表
 * @param parameter
 * @returns {AxiosPromise}
 */
export function lading_bill_attachment_list (parameter) {
  return request({
    url: lading_billApi.trade_lading_bill_attachment,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 担保合同附件添加
 */
export function lading_bill_attachment_create (parameter) {
  return request({
    url: lading_billApi.trade_lading_bill_attachment,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 担保合同附件删除
 */
export function lading_bill_attachment_delete (contract_attachment_id) {
  return request({
    url: lading_billApi.trade_lading_bill_attachment + contract_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
